/* Types */
import {
  Code,
  DeliveryType,
  Info,
  RequestCode,
  Statistics,
  UserInfo,
  UserStatistics,
} from '@/api/modules/user/types'

/**
 * Формируем объект по UserInfo
 * @param userInfo - данные пользователя
 */
export const getMappedUserInfo = (userInfo: UserInfo): Info => {
  return {
    birthday: userInfo.birthday ?? '',
    email: userInfo.email ?? '',
    fullName: userInfo.full_name ?? '',
    mobile: userInfo.mobile ?? '',
    mobile_formatted: userInfo.mobile_formatted ?? '',
    receiveEmail: userInfo.receive_email ?? false,
    receiveMobilePush: userInfo.receive_mobile_push ?? false,
    receiveSms: userInfo.receive_sms ?? false,
    receiveWebPush: userInfo.receive_web_push ?? false,
    sex: userInfo.sex ?? '',
    clientId: userInfo.client_id ?? '',
    clientHash: userInfo.client_hash ?? '',
    referralPromocodes:
      userInfo.referral_promocodes.length !== 0
        ? userInfo.referral_promocodes
        : [],
  }
}

/**
 * Формируем объект статистики пользователя
 * @param userStatistics - статистика пользователя
 */
export const getMappedUserStatistics = (
  userStatistics: UserStatistics,
): Statistics => {
  return {
    remaining_time_to_annulate: userStatistics.remaining_time_to_annulate ?? 0,
    accounted: userStatistics.accounted ?? 0,
    debited: userStatistics.debited ?? 0,
    bonus: userStatistics.bonus ?? 0,
    ordersCount: userStatistics.orders_count ?? 0,
    promocodesCount: userStatistics.promocodes_count ?? 0,
    rank: userStatistics.rank ?? 0,
    cashback: userStatistics.cashback ?? 0,
  }
}

/**
 * Формируем объект кода авторизации
 * @param code - код авторизации
 */
export const getMappedRequestedCode = (code: RequestCode): Code => {
  return {
    code_length: code.code_length || 0,
    deliveredBy: code.delivered_by || DeliveryType.SMS,
    waitSeconds: code.wait_seconds || 0,
  }
}
